<template>
  <DeepListItemNav :subtitle="subtitle" :title="title" v-bind="$attrs">
    <template #prepend>
      <slot
        v-if="!settingsStore.navDrawerMini && $slots['icon-prepend']"
        name="icon-prepend"
      >
        <v-icon class="icon-prepend">
          {{ iconPrepend }}
        </v-icon>
      </slot>

      <slot v-if="icon || $slots.icon" name="icon">
        <v-icon
          v-tooltip="{
            text: title,
            location: settingsStore.navDrawerMini ? 'right' : 'top',
          }"
          @dblclick="emit('icon:dblclick')"
        >
          {{ icon }}
        </v-icon>
      </slot>
    </template>
  </DeepListItemNav>
</template>

<script lang="ts" setup>
import { DeepListItemNav } from '@deepcloud/deep-ui-lib'
import { useSettingsStore } from '@/stores/settings/settings'

defineProps({
  title: {
    type: String,
    default: undefined,
  },
  subtitle: {
    type: String,
    default: undefined,
  },
  icon: {
    type: String,
    default: undefined,
  },
  iconPrepend: {
    type: String,
    default: undefined,
  },
})

const emit = defineEmits(['icon:dblclick'])

const settingsStore = useSettingsStore()
</script>

<style lang="scss">
.deep-list-item-nav {
  margin-top: 0 !important;

  .v-list-item__prepend {
    .v-icon {
      margin-inline-start: 8px !important;
    }
  }
}
</style>
